import React from "react"
import { Button, Flex } from "antd"

import { IconCopy } from "@src/app/components/icons/copy"
import { notify } from "@src/app/components/notify"

type Props = {
  buttonClassName?: string
  buttonWrapperClassName?: string
  content: string
  message?: string
  style?: React.CSSProperties
  view?: React.ReactElement
}
export const WithCopy = ({
  buttonClassName,
  buttonWrapperClassName,
  content,
  message = "Copied to clipboard",
  style,
  view,
}: Props) => {
  const handleClick = (): void => {
    navigator.clipboard.writeText(content)

    notify.success(message)
  }

  const button = (
    <Button
      className={buttonClassName}
      icon={<IconCopy height={13} width={13} />}
      id="GENERATED_ID_COPYBLOCK_BUTTON_VOID_1"
      onClick={handleClick}
      style={{ height: 20, minWidth: 20, padding: 0, width: 20 }}
      type="text"
    ></Button>
  )

  return (
    <Flex align={"center"} gap={8} style={style}>
      <span style={{ minWidth: 0, overflow: "hidden", whiteSpace: "nowrap" }}>
        {view ?? content}
      </span>
      <span className={buttonWrapperClassName}>{button}</span>
    </Flex>
  )
}
